/** Pure barrel — re-exports only side-effect-free modules */
export * from "./occlusionMaterial.pure";
